

























import Vue from "vue";
import AdvertisementForm from "@/components/Form/AdvertisementForm.vue";
import AdvertisementPreview from "@/components/Form/AdvertisementPreview.vue";
import Advertisement from "../../../entity/Advertisement";
export default Vue.extend({
  components: { AdvertisementForm, AdvertisementPreview },
  methods: {
    async next() {
      switch (this.phase) {
        case "input":
          this.isLoading = true;
          await this.validate();
          this.phase = "confirm";
          this.isLoading = false;
          break;
        case "confirm":
          this.isLoading = true;
          await this.save();
          this.$router.push({
            name: "AdministratorAdvertisementsComplete",
            params: {
              id: "1"
            }
          });
          this.isLoading = false;
          break;
      }
    },
    async prev() {
      switch (this.phase) {
        case "confirm":
          this.phase = "input";
          break;
      }
    },
    async validate() {
      return new Promise(resolve => {
        setTimeout(resolve, 1000);
      });
    },
    async save() {
      return new Promise(resolve => {
        setTimeout(resolve, 1000);
      });
    }
  },
  computed: {
    documentMd() {
      return `
# 広告主 広告編集

`;
    }
  },
  data() {
    return {
      isLoading: false,
      phase: "input",
      advertisement: (() => {
        const adv = new Advertisement();
        adv.title = "家を売るならgoguyホーム";
        adv.body1 = "家を売るならgoguyホーム";
        return adv;
      })()
    };
  }
});
